import React, { useCallback } from 'react'
import Loading from 'src/components/Loading'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import { eventTrack } from 'src/components/GoogleTagManager'
import { slugfy } from 'src/utils/formatters'

import { Wrapper, Container, TextWrap, Title, Text, Image, ButtonTag } from './style'


export default function NascemosParaFacilitar() {
	const { data, isLoading } = useFetchContent()
	const {
		tituloTopo,
		descricaoTopo,
		corDeFundoTopo,
		textColor,
		imagemTopo,
		corDoBotao,
		textoBotao,
		corTextoBotao
	} = getSection({ sectionName: 'landingDoubleSection', data })
	
	const scrollToOffer = useCallback(() => {
		const el = document.querySelector("#plans");
		const yOffset = -80;
		const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
	
		window.scrollTo({ top: y, behavior: "smooth" });
	}, []);

	if(isLoading || !data) return <Loading />
	
	return (
		<Wrapper style={{ backgroundColor: corDeFundoTopo }}>
			<Container>
				<Image
					src={`https://${imagemTopo.fields.file.url}`}
					alt={imagemTopo.fields.title}
				/>
				<TextWrap>
					<Title color={textColor}>{tituloTopo}</Title>
					<Text color={textColor} dangerouslySetInnerHTML={{__html: descricaoTopo}}/>
					<ButtonTag 
						background={corDoBotao}
						color={corTextoBotao} 
						onClick={() => {
							scrollToOffer();
							eventTrack(
								'veloe:institucional',
								'clique:botao',
								'nascemos-para-facilitar:' + slugfy(textoBotao)
							);
						}}
						>{textoBotao}
					</ButtonTag>
				</TextWrap>
			</Container>
		</Wrapper>
	)
}
